import { render, staticRenderFns } from "./SettleSurveyCard.vue?vue&type=template&id=45936156&"
import script from "./SettleSurveyCard.vue?vue&type=script&lang=js&"
export * from "./SettleSurveyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports